import { render, staticRenderFns } from "./TheCookieBanner.vue?vue&type=template&id=5fb1cbbe&scoped=true"
import script from "./TheCookieBanner.vue?vue&type=script&lang=js"
export * from "./TheCookieBanner.vue?vue&type=script&lang=js"
import style0 from "./TheCookieBanner.vue?vue&type=style&index=0&id=5fb1cbbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb1cbbe",
  null
  
)

export default component.exports